import type { Schemas } from '@npc/api-client'

import { api } from './api'
import { call } from './errors'

export type ProjectRepositories = Schemas['ProjectRepositories']
export type ProjectRepositoryCandidates = Schemas['ProjectRepositoryCandidates']
export type ProjectRepositoryCandidate = Schemas['ProjectRepositoryCandidate']
export type ProjectRepositoryLinkRequest = Schemas['ProjectRepositoryLinkRequest']
export type ProjectRepositoryLinkResult = Schemas['ProjectRepositoryLinkResult']

export async function listProjectRepositories(projectId: string): Promise<ProjectRepositories> {
  return call('/projects/{projectId}/repositories', () =>
    api.GET('/projects/{projectId}/repositories', { params: { path: { projectId } } }),
  )
}

export async function listProjectRepositoryCandidates(
  projectId: string,
): Promise<ProjectRepositoryCandidates> {
  return call('/projects/{projectId}/repository-candidates', () =>
    api.GET('/projects/{projectId}/repository-candidates', { params: { path: { projectId } } }),
  )
}

export async function linkProjectRepository(
  projectId: string,
  input: ProjectRepositoryLinkRequest,
): Promise<ProjectRepositoryLinkResult> {
  return call('/projects/{projectId}/repositories', () =>
    api.POST('/projects/{projectId}/repositories', {
      params: { path: { projectId } },
      body: input,
    }),
  )
}
